const unchecked = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect
      x="4"
      y="4"
      width="16"
      height="16"
      rx="8"
      fill="white"
      stroke="currentColor"
      strokeWidth="1.5"
      opacity="0.3"
    />
  </svg>
);

const checked = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect
      x="4"
      y="4"
      width="16"
      height="16"
      rx="8"
      fill="var(--pique-green-primary)"
    />
    <path
      d="M9 12L11 14L15 10"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const indeterminate = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect
      x="4"
      y="4"
      width="16"
      height="16"
      rx="8"
      fill="var(--pique-green-primary)"
    />
    <rect
      x="9"
      y="11"
      width="6"
      height="2"
      rx="1"
      fill="white"
    />
  </svg>
);

export { checked, indeterminate, unchecked };
